import { BaseElement } from '../../../../../../api/com/MetaPattern/MDA/MD/Base/BaseElement';
import * as joint from 'jointjs';
import { MDBaseShape } from './MDBaseShape';

/**
 * 矩形图形
 * 带有标题行及矩形内容区域的图形，内容区域的呈现由子类自行定义
*/
export abstract class RectShape extends MDBaseShape {
  /** 重写超类属性 */
  defaults() {
    return {
      ...super.defaults,
      // 定义图形的实际类型
      type: 'mst.RectShape',
      attrs: {
        rect: { 'stroke-width': 0, fill: '#FFFFFF' },
        '.uml-comment-container': { fill: '#ffffc0', strokeWidth: 2, stroke: '#545c64', cursor: 'move' },
        '.uml-comment-text': { fontSize: 12 }
      },
      position: { x: 10, y: 10 }
    };
  }

  /**
   * 反序列化构造器，由joint框架默认调用。
   * 1、重写属性
   * 2、设置自定义属性
   * 3、自定义属性反序列化的自行处理
   * @param attributes 从JSON构造
   * @param opt 图形
   */
  constructor(attributes?: any, opt?: any) {
    // 调用超类的构造器
    super(attributes, opt);
    // 重写图形，如果放在defaults上面会覆盖超类，这里只会修改不一致的项，Very Important
    this.attr({
      body: { fill: '#ffffc0', stroke: '#545c64' },
      label: {
        fill: '#000000',
        fontSize: 12
      }
    });
    this.initialize();
  }

  initialize() {
    this.updateRectangles();
    joint.shapes.basic.Generic.prototype.initialize.apply(this, [this.attributes]);
  }

  doAction(action: string): BaseElement | null {
    return super.doAction(action);
  }

  /** 输出图形的代码 */
  protected abstract updateRectangles(setWidth?: number, setHeight?: number): void;

  /** 添加子元素的克隆 */
  addChildClone(element: BaseElement, elements: Array<BaseElement>): BaseElement | null {
    return null;
  }
}
